<template>
	<div class="page display-none" v-if="isHidden" :index="index" />
	<img class="page" :src="src" :srcset="srcset" :sizes="sizes" :style="pageStyle" :class="pageClass" :index="index" v-else-if="isRendered" />
	<div class="page white--text preview-page" :style="pageStyle" v-else>
		Rendering
		<br/>
		Preview
		<br/>
		Please
		<br/>
		Wait
	</div>
</template>

<script>
const MIN_PRELOAD = 6;

export default {
	props: {
		page: null,
		currentPage: null,
		pageCount: null,
		index: null,
		isMobile: null,
		goingForward: null,
		alone: null
	},
	computed: {
		src() {
			if(this.page) {
				return this.page.large;
			} else {
				return null;
			}
		},
		srcset() {
			if(this.page) {
				return [
					this.page.small + ' 400w',
					this.page.medium + ' 1000w',
					this.page.large + ' 2000w'
				].join(', ');
			} else {
				return '';
			}
		},
		sizes() {
			return '(max-width: 1200px) 1000w, 2000w';
		},
		pageStyle() {
			let styles = {
				'z-index': 999 - this.index
			};
			if(this.index <= this.currentPage) {
				styles['z-index'] = 999 + this.index;
			} else if(this.index === this.currentPage + 2 && !this.goingForward) {
				styles['z-index'] = 999 + this.index;
			}

			let extraIndex = this.isMobile ? 0 : 1;
			if(this.index < this.currentPage || this.index > (this.currentPage + extraIndex)) {
				// styles.display = 'none';
			} else if(this.isMobile) {
				styles['max-width'] = '100%';
			}

			return styles;
		},
		pageClass() {
			let classes = {
				left: this.index % 2 === 0,
				right: this.index % 2 === 1
			};

			if(this.index <= this.currentPage || this.index === (this.currentPage - 1)) {
				classes['turning'] = true;
			}
			classes.alone = this.alone;
			
			// Hide pages further in front cover isn't displaying with other pages
			let extraForwardIndex = 1;
			if(!this.goingForward) {
				extraForwardIndex++;
			}
			if(this.currentPage < 2 && this.index > (this.currentPage + extraForwardIndex)) {
				classes.hidden = true;
			}

			// When turning to page 1/2 don't want page 3 to briefly show
			let extraBackIndex = 1;
			if(this.goingForward && this.currentPage < this.pageCount) {
				extraBackIndex++;
			}
			if((this.currentPage === 2 && this.goingForward && this.index > (this.currentPage + 1)) || 
				(this.currentPage >= this.pageCount - 2 && this.index < this.currentPage - extraBackIndex)) {
				classes['simple-hidden'] = true;
			}

			if(this.index <= 3 || this.index > this.pageCount - 3) {
				classes['hidden-animation'] = true;
			}

			return classes;
		},
		isHidden() {
			if(this.index > this.currentPage + MIN_PRELOAD || this.index < this.currentPage - MIN_PRELOAD) {
				return true;
			} else {
				return false;
			}
		},
		isRendered() {
			return !this.page || this.page.large != 'pdf-thumbnail-rendering';
		}
	}
};
</script>

<style scoped>
	.page {
		max-height: 100%;
		max-width: 50%;
		flex-shrink: 1;
		pointer-events: none;
		-webkit-user-select: none;
		user-select: none;
		object-fit: scale-down;

		backface-visibility: hidden;
		transition: transform 0.9s cubic-bezier(0.645, 0.045, 0.355, 1);
	}
	.page.hidden-animation {
		transition: transform 0.9s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.9s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.9s cubic-bezier(0.645, 0.045, 0.355, 1);
	}
	.page.display-none {
		display: none;
	}

	.left.page {
		position: absolute;
		right: 50%;
		
		transform-origin: 100% 0%;
		transform: rotateY(180deg);
		
		border-radius: 24px 0px 0px 24px;
		box-shadow: -1px -1px 0 #dcdcdc,
			-4px -4px 0 #d1d1d1,
			-6px -6px 0 #bfbfbf,
			-8px -8px 0 #aeaeae,
			-10px -10px 0 #9c9c9c,
			-11px -11px 0 #200f3c,
			0px -1px 0px #200f3c,
			-2px -3px 0px #200f3c,
			-4px -5px 0px #200f3c,
			-6px -7px 0px #200f3c,
			-8px -9px 0px #200f3c,
			-10px -11px 0px #200f3c;
	}
	.right.page {
		position: absolute;
		left: 50%;

		transform-origin: 0% 0%;

		border-radius: 0px 16px 16px 0px;
		box-shadow: 1px -1px 0 #dcdcdc,
			4px -4px 0 #d1d1d1,
			6px -6px 0 #bfbfbf,
			8px -8px 0 #aeaeae,
			10px -10px 0 #9c9c9c,
			11px -11px 0 #200f3c,
			0px -1px 0px #200f3c,
			2px -3px 0px #200f3c,
			4px -5px 0px #200f3c,
			6px -7px 0px #200f3c,
			8px -9px 0px #200f3c,
			10px -11px 0px #200f3c;
	}

	@media only screen and (max-width: 800px) {
		.left.page {
			border-radius: 8px 0px 0px 8px;
		}
		.right.page {
			border-radius: 0px 8px 8px 0px;
		}

	}

	.right.page.alone:not(.turning) {
		left: 50%;
		transform: translate(-50%, 0%);
	}
	.page.alone {
		border-radius: 0px 0px 0px 0px;
	}
	.hidden.page {
		left: 50%;
		transform: translate(-50%, 0%);
		opacity: 0;
	}
	.simple-hidden.page {
		opacity: 0;
	}

	.left.page.turning {
		transform: rotateY(0deg);
	}
	.right.page.turning {
		transform: rotateY(-180deg);
	}

	.preview-page {
		margin-left: 1em;
		margin-right: 1em;
	}
</style>